var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('course-list',{attrs:{"is_component_use_in_student_access":"","use_with_emit":true},on:{"courseDetails":_vm.handleCourseDetails}}),_c('dialog-show-course-details',{attrs:{"dialog":_vm.dialog,"course":_vm.selected_course_details},on:{"closeDialog":_vm.handleCloseDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }